import DataFormulaNode from "./DataFormulaNode.js";

/**
 * TODO: write documentation
 */
export default class AverageDataFormulaNode extends DataFormulaNode {
	static getType() {
		return "AverageDataNode";
	}
}
